import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Profile from "../components/Profile";
import ListedBusiness from "../components/ListedBusiness";
import Package from "../components/Package";
import API_BASE from "../config/api";
import UserProfile from "../components/UserProfile";
import MyListings from "../components/MyListings";

export default function Admin() {
    const [activePage, setActivePage] = useState("UserProfile");
    const [username, setUsername] = useState("");
    const [userData, setUserData] = useState(null);

    const location = useLocation();

    console.log("🔥 Admin component loaded");

    // ---------------------------------------
    // 1️⃣ Get userid from URL
    // ---------------------------------------
    const queryParams = new URLSearchParams(location.search);
    const userid = queryParams.get("userid");

    console.log("📌 URL userid:", userid);

    // ---------------------------------------
    // 2️⃣ Get Fullname from localStorage
    // ---------------------------------------
    useEffect(() => {
        const saved = localStorage.getItem("user");
        console.log("📦 Raw localStorage user:", saved);

        if (saved) {
            try {
                const u = JSON.parse(saved);
                console.log("👤 Parsed localStorage user:", u);

                setUsername(u.fullname ?? "Admin");
            } catch (e) {
                console.error("❌ Error parsing localStorage user:", e);
            }
        } else {
            console.warn("⚠️ No user found in localStorage");
        }
    }, []);

    // ---------------------------------------
    // 3️⃣ API Call → Get full userData
    // ---------------------------------------
    useEffect(() => {
        if (!userid) {
            console.warn("⚠️ No userid in URL — cannot fetch userData");
            return;
        }

        const apiURL = `${API_BASE}/api/userdata.php?userid=${userid}`;
        console.log("🌐 Calling API:", apiURL);

        fetch(apiURL)
            .then((res) => res.json())
            .then((res) => {
                console.log("📥 API Response:", res);

                if (res.success) {
                    console.log("✅ User data received:", res.data);
                    setUserData(res.data);
                } else {
                    console.error("❌ API returned error:", res.message);
                }
            })
            .catch((err) => {
                console.error("💥 Fetch error:", err);
            });
    }, [userid]);

    console.log("📌 Final userData before render:", userData);

    return (
        <div className="d-flex bg-light" style={{ minHeight: "100vh" }}>

            {/* LEFT SIDEBAR (sticky & not scrollable on desktop) */}
            <div
                className="sidebar-wrapper"
                style={{
                    position: "sticky",
                    top: 0,
                    height: "100vh",
                    overflowY: "hidden",  // << no scroll on desktop
                    flexShrink: 0         // keep width fixed
                }}
            >
                <Sidebar active={activePage} onChange={setActivePage} username={username} />
            </div>

            {/* RIGHT CONTENT (scrollable) */}
            <div
                className="flex-grow-1 p-4"
                style={{
                    height: "100vh",
                    overflowY: "auto", // page scroll here only
                }}
            >
                <div className="container-fluid">
                    {activePage === "UserProfile" && <UserProfile userData={userData} />}
                    {activePage === "MyListings" && <MyListings userData={userData} />}
                    {activePage === "package" && <Package userData={userData} />}
                </div>
            </div>

        </div>
    );


}
